<template>
  <div class="defect-input">
    <div class="form-group row">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <div class="toolbar text-right mb-3">
          <button v-if="value.length" type="button" class="mt-1 btn btn-secondary" @click="toggleAll()">
            <i class="fa" :class="expandAccordians ? 'fa-chevron-up' : 'fa-chevron-down'"></i> All
          </button>
          <button type="button" class="mt-1 btn btn-primary" @click="newSection()">
            <i class="fa fa-plus"></i> Add Custom Section
          </button>
          <button type="button" class="mt-1 btn btn-danger" @click="resetSectionsModal()">
            <i class="fa fa-retweet"></i> Reset Sections
          </button>
        </div>
        <draggable :value="this.value" @input="customValidate($event)">
          <div v-for="(val, index) in this.value" :key="index">
            <div class="card mb-3">
              <accordian-display
              ref="accordians"
              :defaultOpen="true"
              :draggable="true"
              :title="'Section #' + (index + 1) + ' - ' + val.heading"
              :icon="'fa fa-fw fa-list-ol'">
                <div class="card-body text-dark">
                  <text-input
                    v-model="val.heading"
                    :options="{
                      label: 'Heading',
                      name: 'heading',
                      value: val.heading,
                      fullWidth: true
                    }">
                  </text-input>
                  <div class="tfm-textarea"
                    v-if="val && val.type === 'custom'"
                    @click="openTextEditor(val, index)"
                    v-html="val.text">
                  </div>
                </div>
              </accordian-display>
              <div class="card-footer text-right" v-if="val.canRemove">
                <button @click.prevent="removeSection(val)" class="my-1 btn btn-danger"><i class="fa fa-trash"></i> Remove</button>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <modal
      v-if="editingText"
      :title="'Edit Description'"
      :is-open="editingText"
      @dismiss="closeModal()">
      <rich-text-input :options="editorOpts" v-model="editorOpts.value">
      </rich-text-input>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="closeModal()">
          Done
        </button>
      </div>
    </modal>
    <modal
      v-if="youSureMate"
      :title="'Confirm'"
      :is-open="youSureMate"
      @dismiss="dismissModal()">
      <div class="alert alert-danger">
        Are you sure? Any custom sections or video sections will be removed.
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-primary" @click="resetSections()">
          Confirm
        </button>
        <button type="button" class="btn btn-secondary" @click="dismissModal()">
          Cancel
        </button>
      </div>
    </modal>
    <div class="modal-backdrop fade show" v-show="editingText || youSureMate"></div>
  </div>
</template>

<script>
  import Modal from '@/components/ui/Modal'
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import Draggable from 'vuedraggable'
  import RichTextInput from '@/components/inputs/RichTextInput'
  import { OPEN_MODAL, CLOSE_MODAL, COMPONENT_METHOD } from '@/vuex/types'
  import TextInput from '@/components/inputs/TextInput'
  import {
    validationClass,
    validationIcon,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'ReportSectionsInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      AccordianDisplay,
      Draggable,
      RichTextInput,
      TextInput,
      Modal
    },
    data () {
      return {
        expandAccordians: true,
        isDirty: false,
        isValid: false,
        videos: false,
        editorOpts: {},
        editingText: false,
        youSureMate: false
      }
    },
    computed: {
      validationClass,
      validationIcon,
      validationMessage
    },
    mounted () {
      if (this.options.videoField) this.addVideoField()
      this.validate(this.value)
    },
    methods: {
      resetSectionsModal () {
        this.youSureMate = true
        this.$store.dispatch(OPEN_MODAL, {
          title: 'Confirm',
          alreadyOpen: true
        })
      },
      resetSections () {
        let values = [
          {
            heading: 'Inspection Notes',
            type: 'notes',
            canRemove: false
          },
          {
            heading: 'Detailed Defect Report',
            type: 'report',
            canRemove: false
          }
        ]
        this.videos = false
        this.validate(values)
        this.dismissModal()
      },
      customValidate ($event) {
        this.$emit('input', $event)
      },
      toggleAll () {
        let method = 'close'
        if (!this.expandAccordians) method = 'open'
        this.$store.dispatch(COMPONENT_METHOD, { method, payload: this.$refs.accordians })
        this.expandAccordians = !this.expandAccordians
      },
      newSection () {
        this.expandAccordians = true
        let value = this.value
        value.push({
          heading: '',
          text: '',
          type: 'custom',
          added: (Math.random() + 1).toString(36).substring(7),
          canRemove: true
        })
      },
      addVideoField () {
        let hasVideo = this.value.find(el => el.type === 'videos')
        if (!hasVideo) {
          this.expandAccordians = true
          this.videos = true
          let value = this.value
          value.push({
            heading: 'Videos',
            type: 'videos',
            canRemove: false
          })
        }
      },
      validate (val = this.value) {
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      removeSection (image) {
        let values = this.value
        values.splice(values.indexOf(image), 1)
        this.$emit('input', values)
      },
      runWatcher (val, name) {
        if (this.options.watchers.includes(name)) {
          if (val) {
            switch (name) {
              case 'videos':
                if (!this.videos) {
                  this.addVideoField()
                } else if (!val.length) {
                  this.videos = false
                  let value = this.value
                  let videoField = value.find(el => el.type === 'videos')
                  value.splice(value.indexOf(videoField), 1)
                  this.validate(value)
                }
                break
            }
          }
        }
      },
      openTextEditor (val, index) {
        this.editorOpts = {
          index,
          name: 'textEditor',
          fullWidth: true,
          value: val.text
        }
        this.editingText = true
        this.$store.dispatch(OPEN_MODAL, {
          title: 'Edit Description',
          alreadyOpen: true
        })
      },
      async closeModal () {
        tinymce.triggerSave()
        let newDescription = tinymce.activeEditor.getContent({format: 'raw'})
        await this.$nextTick()
        let values = this.value
        values[this.editorOpts.index].text = newDescription
        this.$emit('input', values)
        this.editingText = false
        this.$store.commit(CLOSE_MODAL, 0)
      },
      async dismissModal () {
        this.youSureMate = false
        this.$store.commit(CLOSE_MODAL, 0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/ReportSectionsInput.vue